import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Nav from "../../navigation/Nav";
import Menu from "../../navigation/Menu";
import "moment/locale/nl";
import { AiOutlineLeft } from "react-icons/ai";
import "../../../scss/customers/create_customer.scss";
import "../../../scss/customers/customer.scss";
import Swal from "sweetalert2";

// API functions
import { create_customer } from "../../../functions/api.js";
import ObjectenSection from "../objecten/ObjectenSection";

const Field = ({ label, name, type = "text", data, onChange }) => (
  <div>
    <label className="label-customer" htmlFor={name}>{label}</label>
    <div className="input-color">
      <input
        type={type}
        id={name}
        name={name}
        value={data[name]}
        onChange={onChange}
        autoComplete="on"
      />
    </div>
  </div>
);

function CreateCustomer() {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [objects, setObjects] = useState([]);

  const [customerData, setCustomerData] = useState({
    telefoon: "",
    email: "",
    website: "",
    klantnaam: "",
    bedrijfsnaam: "",
    adres: "",
    huisnummer: "",
    postcode: "",
    plaats: "",
  });

  // Submit on enter key
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.code === "Enter") {
        event.preventDefault();
        submitData();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCustomerData((prev) => ({ ...prev, [name]: value }));
  };

  const submitData = async () => {
    setIsSaving(true);
    try {
      const formattedObjects = objects.map((object) => ({
        ...object,
        contactpersoon: { ...object.contactpersoon, contactpersoonid: 0 },
        locatie: { ...object.locatie, locatieid: 0, locatienaam: "" },
        klantid: "",
        objectid: "",
      }));

      const customerPayload = {
        id: "",
        telefoon: customerData.telefoon || "",
        email: customerData.email || "",
        website: customerData.website || "",
        klantnaam: customerData.klantnaam || "",
        bedrijfsnaam: customerData.bedrijfsnaam || "",
        locatie: {
          locatieid: 0,
          locatienaam: "",
          adres: customerData.adres || "",
          huisnummer: customerData.huisnummer || "",
          postcode: customerData.postcode || "",
          plaats: customerData.plaats || "",
        },
        objecten: formattedObjects,
        toch_aanmaken: false,
      };

      const response = await create_customer(customerPayload);

      if (response.response) {
        navigate("/customers");
      } else if (response.message) {
        Swal.mixin({
          customClass: { confirmButton: "btn btn-success mx-2", cancelButton: "btn btn-danger mx-2" },
          buttonsStyling: false,
        })
          .fire({
            title: "Pas op!",
            text: response.message,
            showCancelButton: true,
            confirmButtonText: "Toch aanmaken",
            cancelButtonText: "Annuleren",
            reverseButtons: true,
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              customerPayload.toch_aanmaken = true;
              await create_customer(customerPayload);
              navigate("/customers");
            }
          });
      } else {
        Swal.fire({ title: "Er is iets fout gegaan", icon: "error", confirmButtonText: "Ok" });
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      Swal.fire({ title: "Er is iets fout gegaan", icon: "error", confirmButtonText: "Ok" });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="select-customer-container-main">
      <Nav page="Rapportages" />
      <div className="page-wrap-row">
        <Menu className="menu-container" />
        <div className="create-customer">
          <Link
            className="fixed bottom-0 left-0 ml-4 mb-4"
            to="/customers"
            style={{ textDecoration: "none", color: "#757575", width: "85px" }}
          >
            <p className="text-base flex flex-row">
              <AiOutlineLeft className="mt-1" />
              terug
            </p>
          </Link>

          <div>
            <h1 className="customer-header mt-12 md:mt-10 lg:mt-8">Klant</h1>
            <hr className="hr2" />
          </div>

          <div style={{ paddingBottom: 16 }}>
            {/* Naam + Bedrijfsnaam */}
            <div className="grid grid-cols-2 gap-4 mb-6">
              <Field label="Naam" name="klantnaam" data={customerData} onChange={handleChange} />
              <Field label="Bedrijfsnaam" name="bedrijfsnaam" data={customerData} onChange={handleChange} />
            </div>

            {/* Adres */}
            <div className="mb-6">
              <Field label="Adres (straat)" name="adres" data={customerData} onChange={handleChange} />
            </div>

            {/* Postcode + Huisnummer + Plaats */}
            <div className="grid grid-cols-3 gap-4 mb-6">
              <Field label="Postcode" name="postcode" data={customerData} onChange={handleChange} />
              <Field label="Huisnummer" name="huisnummer" data={customerData} onChange={handleChange} />
              <Field label="Plaats" name="plaats" data={customerData} onChange={handleChange} />
            </div>

            {/* Telefoon + Email */}
            <div className="grid grid-cols-2 gap-4 mb-6">
              <Field label="Telefoon" name="telefoon" data={customerData} onChange={handleChange} />
              <Field label="Email" name="email" data={customerData} onChange={handleChange} />
            </div>

            {/* Website */}
            <div className="mb-6">
              <Field label="Website" name="website" data={customerData} onChange={handleChange} />
            </div>

            <ObjectenSection
              objecten={objects}
              customerDefaults={{
                klantid: "",
                locatie: {
                  adres: customerData.adres,
                  huisnummer: customerData.huisnummer,
                  postcode: customerData.postcode,
                  plaats: customerData.plaats,
                },
              }}
              onChange={setObjects}
            />

          </div>
          <div className="sticky-action-bar">
            <button
              className="submit-customer"
              onClick={submitData}
              disabled={isSaving}
            >
              {isSaving ? "Bezig..." : "Aanmaken"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateCustomer;
